import React from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container, Row, Col, Form, Button} from "react-bootstrap";
import Section from "../Components/Section";

import jsonImg3 from "../Content/json3.JPG";
import useDocumentTitle from "../hooks/useDocumentTitle"; 

class How extends React.Component {

  render(
    
  ) {
    
    return (
      <div id="howTo">
            <Container id="foot">
                <h1>How Our Tool Works !</h1>
                <br/>
                <br/>
                <Section
                img={jsonImg3}
                first={true}
                >
                    <br/>
                    <br className="d-none d-lg-flex" />
                    
                    <br className="d-none d-lg-flex" />
                    <h3>Making JSON More Human Readable</h3>
                    <br className="d-none d-lg-flex" />
                    <p>JSON is Great but one of its drawbacks is the limitations of being user friendly for first timers. We hope to address this with our tool.</p>
                    <br className="d-none d-lg-flex" />
                    <p>Simply paste your JSON code in the editor window and have your values color coded. Simply click to collapse/expand your JSON Objects and Arrays.</p>
                  
                </Section>
                

            </Container>
      </div>
    );
  }
  
}
export default How;

